import {getJson} from '../ajax/ajax'
import {SEARCH_PATH, PUBLIC_SEARCH_PATH} from './../ajax/sdgOnlinePaths';
import {ValidationError, OptimisticLockingError} from "../util/errors";

const handleResponse = (response) => {
  return {data: response.data};
}

const handleError = (error) => {
  // if its a 400 its a validation error, the response payload will be an errors object built by ValidationExceptionToJsonStrategyImpl
  if (error.request) {
    if (error.status === 400) {
      throw new ValidationError(error.data);
    }
    else if (error.status === 409)
    {
      throw new OptimisticLockingError();
    }
  }
  throw error;
};


export default class DocumentSearchApi {

  static doSearch(searchTerm, pageNumber = 0) {
    return getJson(SEARCH_PATH, {searchTerm, pageNumber, pageSize : 10}).then(handleResponse, handleError);
  }

  static doPublicSearch(searchTerm, pageNumber = 0) {
    return getJson(PUBLIC_SEARCH_PATH, {searchTerm, pageNumber, pageSize : 10}).then(handleResponse, handleError);
  }

}